import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ItinerantActions() {
  const [ref, vis] = useScrollReveal();

  return (
    <section id="acoes" data-testid="itinerant-section" className="py-20 sm:py-28 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center mb-14 transition-all duration-800 ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block px-4 py-1.5 bg-[#E8621A]/10 text-[#E8621A] text-xs font-bold tracking-wider uppercase rounded-full mb-4">
            Nossas Ações
          </span>
          <h2
            data-testid="itinerant-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1A1A2E] mb-4"
            style={{ letterSpacing: '-0.02em' }}
          >
            AÇÕES ITINERANTES SINDPESCA
          </h2>
          <div className="w-20 h-1 bg-[#E8621A] mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Video */}
          <div className="video-container">
            <video
              data-testid="itinerant-video"
              controls
              preload="metadata"
              poster="/images/sections/304a51281682fea9ada5adbcd50e21ab.jpg"
              className="w-full rounded-2xl"
            >
              <source src="/videos/video-itinerante.mp4" type="video/mp4" />
              Seu navegador não suporta vídeos.
            </video>
          </div>

          {/* Text */}
          <div>
            <p className="text-base sm:text-lg text-[#4A5568] leading-relaxed mb-6">
              Somos o Sindicato de Pescadores que mais entregou equipamentos de Pesca para fortalecer a
              produção pesqueira artesanal no Estado do Amapá, com as parcerias certas estamos levando
              mais benefícios para nossos associados.
            </p>
            <p className="text-base sm:text-lg text-[#4A5568] leading-relaxed">
              Através da nossa Diretora de Relações Públicas Maria Ocilene Gomes, garantimos a entrega
              de mais de mil kits de materiais de Pesca, açaicultura e suinocultura para Pescadores,
              Extrativistas e Agricultores do Estado.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#1A8C7A] flex items-center justify-center">
                <i className="fas fa-hand-holding-heart text-white text-xl"></i>
              </div>
              <div>
                <p className="text-2xl font-extrabold text-[#1A8C7A]">+1.000</p>
                <p className="text-sm text-[#4A5568]">Kits de materiais entregues</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
